jQuery(document).ready(
    function ($) {

        $("body").on('click touch', '#search-toggle', function (e) {
            e.preventDefault();
            $("body").removeClass("show-menu");
            $(".hamburger").removeClass("is-active");
            $("body").toggleClass("show-search");
            $(".search-field").focus();
        });

        $("body").on('click touch', '.search-close', function (e) {
            e.preventDefault();
            $("body").removeClass("show-search");
        });

        $("body").on('click touch', '.search-types .facetwp-radio', function (e) {
            // e.preventDefault();
            $("body").removeClass("show-external");
            $("body").removeClass("show-topics");
            $(".search-types-links .checked").removeClass("checked")
        });

        $("body").on('click touch', '.search-types-item[rel="topics"]', function (e) {
            // e.preventDefault();
            $(".search-types-item").removeClass("checked");
            $(this).addClass("checked");
            $(".search-types .facetwp-radio.checked").removeClass("checked")
            $("body").removeClass("show-external");
            $("body").addClass("show-topics");
        });

        $("body").on('click touch', '.search-types-item[rel="external"]', function (e) {
            // e.preventDefault();
            $(".search-types-item").removeClass("checked");
            $(this).addClass("checked");
            $(".search-types .facetwp-radio.checked").removeClass("checked")
            $("body").removeClass("show-topics");
            $("body").addClass("show-external");
        });

    }
);


(function ($) {
    $(document).on('facetwp-loaded', function () {
        if (FWP.loaded) {
            $('html, body').animate({
                scrollTop: $('.site-container').offset().top
            }, 350);
        }
    });
})(jQuery);